import { useFormConfig } from 'config/formConfig/hooks';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';

export const useIsProfiInquiry = () => {
  const { selectedInquiryType } = useFormConfig();
  return [InquiryType.profiRLL, InquiryType.profiMittweida].includes(selectedInquiryType);
};
export default useIsProfiInquiry;
